module.exports = __webpack_public_path__ + "img/完善的数据体系@2x.55528865.png";